/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_SubmittingInputs */

const en_consumer_declaration_submitting = /** @type {(inputs: Consumer_Declaration_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting…`)
};

const de_consumer_declaration_submitting = /** @type {(inputs: Consumer_Declaration_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird übermittelt…`)
};

const fr_consumer_declaration_submitting = /** @type {(inputs: Consumer_Declaration_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi…`)
};

const es_consumer_declaration_submitting = /** @type {(inputs: Consumer_Declaration_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const it_consumer_declaration_submitting = /** @type {(inputs: Consumer_Declaration_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio…`)
};

const nl_consumer_declaration_submitting = /** @type {(inputs: Consumer_Declaration_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzenden…`)
};

const pl_consumer_declaration_submitting = /** @type {(inputs: Consumer_Declaration_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłanie…`)
};

const fi_consumer_declaration_submitting = /** @type {(inputs: Consumer_Declaration_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetetään…`)
};

const da_consumer_declaration_submitting = /** @type {(inputs: Consumer_Declaration_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sender…`)
};

const sv_consumer_declaration_submitting = /** @type {(inputs: Consumer_Declaration_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skickar…`)
};

/**
* | output |
* | --- |
* | "Submitting…" |
*
* @param {Consumer_Declaration_SubmittingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_submitting = /** @type {((inputs?: Consumer_Declaration_SubmittingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_SubmittingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_submitting(inputs)
	if (locale === "fr") return fr_consumer_declaration_submitting(inputs)
	if (locale === "es") return es_consumer_declaration_submitting(inputs)
	if (locale === "it") return it_consumer_declaration_submitting(inputs)
	if (locale === "nl") return nl_consumer_declaration_submitting(inputs)
	if (locale === "pl") return pl_consumer_declaration_submitting(inputs)
	if (locale === "fi") return fi_consumer_declaration_submitting(inputs)
	if (locale === "da") return da_consumer_declaration_submitting(inputs)
	if (locale === "sv") return sv_consumer_declaration_submitting(inputs)
	return en_consumer_declaration_submitting(inputs)
});